import { Popper, styled } from '@mui/material';

export const LocationPopper = styled(Popper, {
  shouldForwardProp: (property) => property !== 'disableRightBorderRadius',
})<{
  disableRightBorderRadius?: boolean;
}>`
  z-index: 9999 !important;

  .MuiPaper-root {
    width: 100%;
    margin-top: 2px;
    border-radius: ${({ theme, disableRightBorderRadius }) =>
      disableRightBorderRadius
        ? `${theme.borderRadius?.secondary}px 0 0 ${theme.borderRadius?.secondary}px`
        : `${theme.borderRadius?.secondary}px`};
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);

    & > .MuiAutocomplete-listbox {
      padding: 8px 0;
    }
  }

  .MuiAutocomplete-noOptions {
    display: none;
  }

  .MuiAutocomplete-listbox {
    padding: 0;

    .MuiAutocomplete-option {
      padding: 0;

      &.Mui-focused,
      &:hover {
        background-color: rgba(0, 0, 0, 0.04);
      }
    }
  }
  /* Apply custom styling only when bookingDropdownStyling is set */
  &.location-search-booking-widget {
    .MuiAutocomplete-option,
    [data-testid='location-search-group-title'],
    .MuiAutocomplete-option h3 {
      // font-size: 1em;
      font-weight: normal;
    }

    .MuiAutocomplete-option p {
      // font-size: 14px;
      font-weight: normal;
    }
  }
`;
